import './App.css';
import Header from 'components/Header';
import { AppContainer } from 'Styles';
import Home from 'pages/Home';
import Footer from 'components/Footer';

const App = () => {
  return (
    <AppContainer>
      <Header />
      <Home/>
      <Footer/>
    </AppContainer>
  );
}

export default App;
